import cn from "classnames";
import React, { ReactNode } from "react";

import { WSText } from "../core/WSText/WSText.component";
import { WSElement, WSElementProps } from "../WSElement/WSElement.component";

import styles from "./WSProgressBar.module.scss";

export interface WSProgressBarProps extends WSElementProps {
  percent: number;
  text?: ReactNode;
  theme?: "error" | "neutral" | "success" | "warning" | "info";
  noAnimation?: boolean;
}

export const WSProgressBar: React.FC<WSProgressBarProps> = ({
  percent = 0,
  text,
  noAnimation,
  theme = "neutral",
  className,
  ...componentProps
}) => (
  <WSElement
    className={cn(className, styles.progressWrapper)}
    role="progressbar"
    aria-valuenow={percent}
    aria-valuemin={0}
    aria-valuemax={100}
    aria-label={typeof text === "string" ? text : undefined}
    {...componentProps}
  >
    <WSElement className={styles.progressBody}>
      <WSElement
        className={cn(styles.progressLine, styles[`theme-${theme}`], {
          [styles.noAnimation]: noAnimation
        })}
        style={{ width: `${percent}%` }}
      />
    </WSElement>
    {typeof text === "string" ? (
      <WSText.ParagraphSm color="gray500" py="S">
        {text}
      </WSText.ParagraphSm>
    ) : text ? (
      text
    ) : null}
  </WSElement>
);
